export default function hasDeletedAccount(profileDeletionStatus) {
  return ['data_deleted', 'completed', 'processing'].includes(profileDeletionStatus?.status);
}
